import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { LiveKitRoom } from '@livekit/components-react'
import { useTranslation } from 'react-i18next'

import type { LocalUserChoices } from '@livekit/components-react'

import { ContinueInApp } from '../../components/Chat/Calls/LiveKitRoom/ContinueInApp'
import { PreJoin } from '../../components/Chat/Calls/LiveKitRoom/PreJoin'
import { Room, asReact17 } from '../../components/Chat/Calls/LiveKitRoom'
import styles from '../../components/Chat/Calls/LiveKitRoom/prejoin.module.css'

import { useGuestMeetingAdmission } from './useGuestMeetingAdmission'

const LiveKit = asReact17(LiveKitRoom)

export const GuestMeeting = () => {
  const { t } = useTranslation()
  const { code } = useParams<{ code: string }>()

  const [choices, setChoices] = useState<LocalUserChoices | null>(null)

  const { admission, isUnreachable, retry } = useGuestMeetingAdmission(code)

  if (isUnreachable) {
    return (
      <main data-lk-theme="default" className={styles.page}>
        <div className={styles.prejoin}>
          <div className={styles.panel}>
            <h1 className={styles.heading}>{t('meetings.guest.unreachableTitle')}</h1>
            <p className={styles.hint}>{t('meetings.guest.unreachableHint')}</p>
            <button type="button" className={styles.joinButton} onClick={() => retry()}>
              {t('meetings.guest.retryButton')}
            </button>
          </div>
        </div>
      </main>
    )
  }

  if (!admission) {
    return (
      <main data-lk-theme="default" className={styles.page}>
        <div className={styles.prejoin}>{t('meetings.guest.joiningLabel')}</div>
      </main>
    )
  }

  if (!choices) {
    return (
      <main data-lk-theme="default" className={styles.page}>
        <PreJoin
          defaults={{
            username: admission.displayName ?? '',
            audioEnabled: true,
            videoEnabled: true
          }}
          onSubmit={setChoices}
        >
          <ContinueInApp meetingCode={code} isHandheld={false} />
        </PreJoin>
      </main>
    )
  }

  return (
    <main data-lk-theme="default" className={styles.page}>
      <LiveKit
        serverUrl={admission.serverUrl}
        token={admission.token}
        connect
        audio={choices.audioEnabled}
        video={choices.videoEnabled}
        data-lk-theme="default"
        className={styles.room}
        onDisconnected={() => setChoices(null)}
      >
        <Room
          onHangup={() => setChoices(null)}
          joinUrl={admission.joinUrl}
          displayName={choices.username}
        />
      </LiveKit>
    </main>
  )
}
